import React, { memo, useCallback, useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { getReWardsList } from '../../services'
import { toast } from '@/utils/bridge'
import Loading from '@/components/Loading'
import './index.scss'

function index() {
    const { t } = useTranslation()
    const [loading, setLoading] = useState(false)
    const [state, setState] = useState<{
        items: RoomRewards.RewardItem[]
    }>({
        items: []
    })
    const refState = useRef(state)
    refState.current = state

    const fetchGetRewardsList = useCallback(async () => {
        setLoading(true)
        const res = await getReWardsList()
        setLoading(false)
        if (!res) return
        if (res.code !== 200) {
            toast(res.message)
            return
        }

        setState({
            ...refState.current,
            items: res.data || [],
        })
    }, [])

    useEffect(() => {
        fetchGetRewardsList()
    }, [])

    return (
        <div className='cmp-rewards'>
            {loading && <Loading />}
            {state.items.map((item, i) =>
                <div className='cmp-rewards__item' key={i}>
                    <div className='cmp-rewards__item-title'>{item.topName}</div>
                    {item.topName === 'remaining pool' && <div className='cmp-rewards__item-sub'>{t('RoomSupport.LastTips')}</div>}
                    <div className='cmp-rewards__items' style={{
                        gridTemplateColumns: `repeat(${Math.min(3, item.rewardList.length)}, 1fr)`
                    }}>
                        {item.rewardList.map((item, j) => <div className='cmp-rewards__item-box' key={j}>
                            <div>
                                <img src={item.rewardIcon} alt="" />
                            </div>
                            <span>{item.rewardName}</span>
                        </div>)}
                    </div>
                </div>
            )}
        </div>
    )
}

export default memo(index)